import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatDialogConfig } from '@angular/material';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DialogboxComponent } from '../dialogbox/dialogbox.component'
import { AppSettings } from '../../app.constant';
import { Program } from 'src/app/shared/class/program';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { SubjectService } from 'src/app/shared/services/subject.service';
import { BatchService } from 'src/app/shared/services/batch.service';
import { StudentsService } from 'src/app/shared/services/students.service';
import { ExaminationService } from 'src/app/shared/services/examination.service';

@Component({
  selector: 'app-marks',
  templateUrl: './marks.component.html',
  styleUrls: ['./marks.component.css']
})

export class MarksComponent implements OnInit {
  httpResponseMessage: any;
  examForm: FormGroup;
  programs: any;
  errorMessage: any;
  post: any;
  module: any;
  modules: any;
  batch: any;
  student: any;
  students: any;
  batches: any;
  PK_ProgramID: any;
  PK_BatchID: any;
  FK_ModuleID: any;
  EnrollmentNo: any;
  FirstName: any;
  FK_StudentID: any;
  ExamSection: any;
  ExamYear: any;
  PK_ExamID: any;
  LastName: any;
  EnrolmentNo: any;
  Subjects: any;
  ExamEntities: any;
  data: any;
  FK_SubjectID: any;
  status: any;
  durationInSeconds = 2;
  role: any = "";
  selectedProgram: Program = new Program(0, 'ABC', 'asd', 'sadasdsa');
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;

  constructor(
    private formbuilder: FormBuilder,
    private _programservice: ProgramService,
    private _moduleservice: ModuleService,
    private _subjectservice: SubjectService,
    private _batchservice: BatchService,
    private _studentservice: StudentsService,
    private _examinationservice: ExaminationService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.examForm = this.formbuilder.group({
      'FK_ProgramID': [''],
      'FK_ModuleID': [''],
      'FK_BatchID': [''],
      'EnrollmentNo': [''],
      'FK_StudentID': [],
      'ExamEntities': this.formbuilder.array([])
    })

    this.getAllProgram();
    this.getModuleByProgramID(this.selectedProgram.PK_ProgramID);

    this.role = sessionStorage.getItem('Role');
  }


  getAllProgram(): void {
    this._programservice.getAllProgram(AppSettings.API_ENDPOINT + AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs = data;
      },
      error => this.errorMessage = <any>error)
  }

  getModuleByProgramID(PK_ProgramID): void {
    this.PK_ProgramID = PK_ProgramID;
    var o = {
      PK_ProgramID: PK_ProgramID
    }
    this.post = JSON.stringify(o);

    this.getBatchByProgramID(PK_ProgramID);
    this._moduleservice.getModuleByProgramID(AppSettings.API_ENDPOINT + AppSettings.GetModuleByProgramID, this.post).subscribe(
      data => {
        this.modules = data;
        //this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
      error => this.errorMessage = <any>error)
  }

  getBatchByProgramID(PK_ProgramID): void {
    var o = {
      PK_ProgramID: PK_ProgramID
    }
    this.post = JSON.stringify(o);
    this._batchservice.GetBatchByProgramID(AppSettings.API_ENDPOINT + AppSettings.GetBatchByProgramID, this.post).subscribe(
      data => {
        this.batches = data;
        // this.batches= this.batch.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
      error => this.errorMessage = <any>error)
  }

  getStudentsByBatchID(PK_BatchID): void {
    this.PK_BatchID = PK_BatchID;
    var o = {
      PK_BatchID: PK_BatchID
    }
    this.post = JSON.stringify(o);
    this._studentservice.getStudentsByBatchID(AppSettings.API_ENDPOINT + AppSettings.GetStudentsByBatchID, this.post).subscribe(
      data => {
        this.students = data;
        // this.students= this.student.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
      error => this.errorMessage = <any>error)
  }

  getEnrollmentNo(EnrollmentNo) {
    this.EnrollmentNo = EnrollmentNo;
  }

  getSubjectByProgramIDModuleID(PK_ModuleID): void {
    this.FK_ModuleID = PK_ModuleID;
    var o = {
      PK_ModuleID: PK_ModuleID,
      FK_ProgramID: this.PK_ProgramID
    }
    this.post = JSON.stringify(o);
    this._subjectservice.getSubjectbyProgramID(AppSettings.API_ENDPOINT + AppSettings.GetSubjectByParam, this.post).subscribe(
      data => {
        this.Subjects = data;
      },
      error => this.errorMessage = <any>error)
  }

  getExamMarksByParam(EnrollmentNo): void {
    this.FK_StudentID = this.EnrollmentNo;
    var o = {
      EnrolmentNo: this.EnrollmentNo,
      PK_StudentID: this.EnrollmentNo,
      FK_ModuleID: this.FK_ModuleID,
      FK_ProgramID: this.PK_ProgramID,
      PK_BatchID: this.PK_BatchID,
      ExamSection: this.ExamSection,
      ExamYear: this.ExamYear
    }
    this.post = JSON.stringify(o);
    this._examinationservice.getExamByParam(AppSettings.API_ENDPOINT + AppSettings.GetExamByParam, this.post).subscribe(
      data => {
        this.data = data;
        this.setSubjects();
      },
      error => this.errorMessage = <any>error)
  }

  createExam(post): void {
    //  if (this.examForm.invalid) { return;  }
    this.post = JSON.stringify(post);
    this._examinationservice.postExamMarks(AppSettings.API_ENDPOINT + AppSettings.CreateExamData, this.post).subscribe(
      data => {
        this.httpResponseMessage = data;
        this.openSnackBar(this.httpResponseMessage, '');
        this.examForm.reset();
      },
      error => this.errorMessage = <any>error)
  }

  deleteExam(index) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: "Marks",
      data: index.SubjectName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        let control = <FormArray>this.examForm.controls.ExamEntities;
        var PK_ExamID = control.value[index].PK_ExamID;
        var o = {
          PK_ExamID: PK_ExamID
        }
        this.post = JSON.stringify(o);
        this._examinationservice.deleteExamByID(AppSettings.API_ENDPOINT + AppSettings.DeleteExam, this.post).subscribe(
          data => {
            this.httpResponseMessage = data;
            this.openSnackBar(this.httpResponseMessage, '');
            // this.examForm.reset();
          },
          error => this.errorMessage = <any>error)
        control.removeAt(index);
      }
    })
  }

  // core subject
  addnewSubject() {
    let control = <FormArray>this.examForm.controls.ExamEntities;
    control.push(
      this.formbuilder.group({
        FK_SubjectID: [],
        SubjectName: [],
        SubjectCode: [],
        CA: [],
        Exam: [],
        Credit: [],
        Grade: [],
        GradePoint: [],
        ExamSection: [],
        ExamYear: [],
        PK_ExamID: [],
      })
    )
  }

  getSubjectIDByName(SubjectName) {
  }

  setSubjects() {
    let control = <FormArray>this.examForm.controls.ExamEntities;
    while (control.length !== 0) {
      control.removeAt(0);
    }

    this.data.forEach(x => {
      // this.FirstName=x.FirstName;
      // this.LastName=x.LastName;
      this.EnrolmentNo = x.EnrolmentNo;
      //this.FK_StudentID=x.PK_StudentID;
      this.FK_SubjectID = x.FK_SubjectID;
      control.push(this.formbuilder.group({
        FK_SubjectID: x.FK_SubjectID,
        SubjectName: x.SubjectName.trim(),
        SubjectCode: x.SubjectCode.trim(),
        CA: x.CA,
        Exam: x.Exam,
        GradePoint: x.GradePoint,
        Grade: x.Grade,
        Credit: x.Credit,
        ExamSection: x.ExamSection,
        ExamYear: x.ExamYear.trim(),
        PK_ExamID: x.PK_ExamID,
      }))
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}

